<template>
  <!-- 联系我们 -->
  <div class="box cus">
    <div v-if="!isM" class="cus0 bgimg"></div>
    <div v-if="isM" class="cusm0"></div>

    <div class="min_box">
      <div class="map_box">
        <div class="mb_l">
          <p>深圳总部</p>
          <ul>
            <li>深圳市易车合创科技有限公司</li>
            <li>总部地址：深圳市南山区深圳湾科技生态园7栋B座西区10楼01-03室</li>
            <li>客服电话：400-822-7177</li>
            <li>工作时间：9:00-18:30（每日）</li>
          </ul>
        </div>
        <div class="mb_r">
          <img v-if="!isM" :src="picUrl + 'map.jpg'" alt="地图" />
          <img v-if="isM" :src="picUrl + 'mapm.jpg'" alt="地图" />
        </div>
      </div>

      <ul class="office_box">
        <li v-for="item in arr" :key="item.id">
          <div>{{ item.site }}办事处</div>
          <p>业务负责人：{{ item.name }}</p>
          <p>联系方式：{{ item.ph }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contactus",
  data() {
    return {
      picUrl: this.$root.picUrl,
      isM: false,
      arr: [
        { site: "广州", name: "胡士茂", ph: "18124529113" },
        { site: "东莞", name: "李建东", ph: "18924661723" },
        { site: "惠州", name: "叶志强", ph: "18575551437" },
        { site: "成都", name: "张德川", ph: "18138410262" },
        { site: "长沙", name: "邓晓燕", ph: "17704074458" },
      ],
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/contactus/contactus.vue